import routeFromRole from 'common/helper/routeFromRole';
import { LoginResponseModel } from 'data/auth/auth.model';
import { onLogin } from 'data/auth/auth.service';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import systemSlice from 'redux/slice/system.slice';

interface KSubmit {
  email: string;
  password: string;
}

export const useLogin = () => {
  const [error, setError] = React.useState<string | null | boolean>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const pushToState = ({ access_token, payload }: LoginResponseModel) => {
    const modifiedPayload = {
      id: payload.id,
      roles: payload.__roles__,
      image: payload.image,
      email: payload.email,
      username: payload.username,
      isLogged: true,
    };

    dispatch(systemSlice.actions.setState(modifiedPayload));
    localStorage.setItem('user_details', JSON.stringify(modifiedPayload));
    localStorage.setItem('token', String(access_token));
    history.push('/' + routeFromRole(payload.__roles__[0].role_code));
  };

  const onLog = async (payload: KSubmit) => {
    setLoading(true);
    try {
      const res = await onLogin(payload);
      pushToState(res);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  return { error, loading, onLogin: onLog };
};
